import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/404",
      alias: "/:_id/404",
      name: "404",
      component: () => import("./views/404.vue"),
    },
    {
      path: "/faq",
      alias: "/:_id/faq",
      name: "faq",
      component: () => import("./views/Faq.vue"),
    },
    {
      path: "/old",
      alias: "/:_id/old",
      name: "old",
      component: () => import("./views/Old.vue"),
    },
    {
      path: "/operation/:opid",
      alias: "/:_id/operation/:opid",
      name: "operation",
      component: () => import("./views/Operation.vue"),
    },
    {
      path: "/form/:opid",
      alias: "/:_id/form/:opid",
      name: "form",
      component: () => import("./views/Form.vue"),
    },
    {
      path: "/forms",
      alias: "/:_id/forms",
      name: "forms",
      component: () => import("./views/Forms.vue"),
    },
    {
      path: "/f2025322",
      alias: "/:_id/f2025322",
      name: "F2025322",
      component: () => import("./views/F2025322.vue"),
    },
    {
      path: "/f2025413",
      alias: "/:_id/f2025413",
      name: "F2025413",
      component: () => import("./views/F2025413.vue"),
    },
    {
      path: "/f2025414",
      alias: "/:_id/f2025414",
      name: "F2025414",
      component: () => import("./views/F2025414.vue"),
    },
    {
      path: "/contact",
      alias: "/:_id/contact",
      name: "contact",
      component: () => import("./views/Contact.vue"),
    },
    {
      path: "/contactdone",
      alias: "/:_id/contactdone",
      name: "contactdone",
      component: () => import("./views/ContactDone.vue"),
    },
    {
      path: "/status/:_subid/:_uid",
      alias: "/:_id/status/:_subid/:_uid",
      name: "status",
      component: () => import("./views/Follow.vue"),
    },
    {
      path: "/operation/informations/suivi-conso",
      name: "suivi2",
      component: () => import("./views/Suivi.vue"),
    },
    {
      path: "/suivi",
      alias: "/:_id/suivi",
      name: "suivi",
      component: () => import("./views/Suivi.vue"),
    },
    {
      path: "/",
      name: "home",
      alias: "/:_id",
      component: () => import("./views/Home.vue"),
    },
  ],
});

// Protection contre les boucles infinies de rechargement
const CHUNK_RELOAD_KEY = 'chunkLoadRetryCount';
const MAX_RELOAD_ATTEMPTS = 1;

function isChunkLoadError(error) {
  return error && (
    /Loading chunk \d+ failed/.test(error.message) ||
    /ChunkLoadError/.test(error.name) ||
    error.message.includes('Loading chunk') ||
    error.message.includes('Failed to fetch dynamically imported module')
  );
}

function handleChunkLoadError() {
  const retryCount = parseInt(sessionStorage.getItem(CHUNK_RELOAD_KEY) || '0', 10);

  if (retryCount < MAX_RELOAD_ATTEMPTS) {
    // Incrémenter le compteur et recharger
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(retryCount + 1));
    console.warn('[ChunkLoadError] Rechargement automatique de la page...', { tentative: retryCount + 1 });
    window.location.reload();
  } else {
    // Limite atteinte - afficher une erreur et réinitialiser
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    console.error('[ChunkLoadError] Limite de rechargements atteinte. Veuillez vider le cache de votre navigateur.');

    // Afficher un message à l'utilisateur
    alert(
      'Une erreur est survenue lors du chargement de la page.\n\n' +
      'Solution : Veuillez vider le cache de votre navigateur (Cmd+Shift+R sur Mac, Ctrl+Shift+R sur Windows) ' +
      'ou forcer le rechargement de la page.'
    );
  }
}

// Réinitialiser le compteur si la page charge correctement
window.addEventListener('load', () => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
});

// Gestion des erreurs du router (lazy loading)
router.onError((error) => {
  if (isChunkLoadError(error)) {
    handleChunkLoadError();
  }
  // Autres erreurs sont gérées par Sentry automatiquement
});

// Gestion globale des erreurs non capturées
window.addEventListener('error', (event) => {
  if (isChunkLoadError(event.error)) {
    event.preventDefault();
    handleChunkLoadError();
  }
});

export default router;
